import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { MenuItem, Select, FormControl, Box } from "@mui/material";
import { statusColors } from "./Status";

// @ts-ignore
export const CanceledStatusSelect = styled(Box)(({ theme }) => ({
  color: theme.palette.common.white,
  backgroundColor: statusColors["Canceled"] || theme.palette.grey[500],
  fontWeight: "bold",
  "& .MuiSelect-select": {
    padding: "8px 16px",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  padding: "10px 20px",
  borderRadius: "6px",
}));

// @ts-ignore
const StatusSelect = styled(Select)(({ theme, value }) => ({
  color: theme.palette.common.white,
  backgroundColor: statusColors[value] || theme.palette.grey[500],
  fontWeight: "bold",
  "& .MuiSelect-select": {
    padding: "8px 16px",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
}));

/**
 * StatusChanger component
 *
 * @param {Object} props - Component props
 * @param {'' | 'New' | 'Processing' | 'Completed' | 'Canceled'} props.initialValue - The initial status value
 * @param {function('New' | 'Processing' | 'Completed' | 'Canceled'): void} props.onChange - Callback function to handle status change
 * @param {Array<'New' | 'Processing' | 'Completed' | 'Canceled'>} [props.options] - The status options
 */
const StatusChanger = ({
  initialValue = "",
  onChange,
  options = ["Processing", "Completed", "Canceled"],
}) => {
  const [status, setStatus] = useState(initialValue);

  const handleStatusChange = (event) => {
    const newStatus = event.target.value;
    setStatus(newStatus);
    onChange(newStatus);
  };

  useEffect(() => {
    setStatus(initialValue);
  }, [initialValue]);

  return initialValue ? (
    <FormControl variant="outlined" fullWidth>
      <StatusSelect value={status} onChange={handleStatusChange} displayEmpty>
        {options?.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </StatusSelect>
    </FormControl>
  ) : null;
};

export default StatusChanger;
